var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.34 73.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#3ac2d4;}.cls-3{fill:#5fc8d9;}.cls-4{fill:#231f20;}.cls-4,.cls-42{fill-rule:evenodd;}.cls-42,.cls-5{fill:#fff;}.cls-6{clip-path:url(#clip-path);}.cls-7{clip-path:url(#clip-path-2);}.cls-8{fill:url(#radial-gradient);}.cls-9{clip-path:url(#clip-path-3);}.cls-10{clip-path:url(#clip-path-4);}.cls-11{fill:url(#radial-gradient-2);}.cls-12{clip-path:url(#clip-path-5);}.cls-13{clip-path:url(#clip-path-6);}.cls-14{fill:url(#linear-gradient);}.cls-15{clip-path:url(#clip-path-7);}.cls-16{clip-path:url(#clip-path-8);}.cls-17{fill:url(#radial-gradient-3);}.cls-18{clip-path:url(#clip-path-9);}.cls-19{clip-path:url(#clip-path-10);}.cls-20{clip-path:url(#clip-path-11);}.cls-21{fill:#7fa2d1;}.cls-22{clip-path:url(#clip-path-12);}.cls-23{clip-path:url(#clip-path-13);}.cls-24{fill:url(#radial-gradient-4);}.cls-25{clip-path:url(#clip-path-14);}.cls-26{clip-path:url(#clip-path-15);}.cls-27{fill:url(#radial-gradient-5);}.cls-28{clip-path:url(#clip-path-16);}.cls-29{clip-path:url(#clip-path-17);}.cls-30{fill:url(#radial-gradient-6);}.cls-31{clip-path:url(#clip-path-18);}.cls-32{clip-path:url(#clip-path-19);}.cls-33{clip-path:url(#clip-path-20);}.cls-34{fill:url(#radial-gradient-7);}.cls-35{fill:#a7a9ac;}.cls-36{clip-path:url(#clip-path-27);}.cls-37{clip-path:url(#clip-path-28);}.cls-38{clip-path:url(#clip-path-29);}.cls-39{clip-path:url(#clip-path-34);}.cls-40{clip-path:url(#clip-path-35);}.cls-41{clip-path:url(#clip-path-36);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.25,
    y: 24.96,
    width: 8.3,
    height: 8.31,
    transform: "translate(8.85 70.74) rotate(-70.57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.32,30.5a4.15,4.15,0,1,1-2.53-5.3,4.15,4.15,0,0,1,2.53,5.3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -214.59,
    cy: -16.34,
    r: 0.04,
    gradientTransform: "matrix(-0.01, -172.02, 171.99, -0.02, 2864.62, -36885.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#aaaaab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7b7b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4d4d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.26,
    y: 29.16,
    width: 3.55,
    height: 2.43,
    transform: "matrix(0.33, -0.94, 0.94, 0.33, 9.43, 74.07)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.81,28.78c.55.31.69,1.11.09,2.27a1.45,1.45,0,0,1-1.63.94c-.62-.22-.72-1.06-.42-1.89s1.25-1.59,1.86-1.37l.1.05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -213.19,
    cy: -18.33,
    r: 0.04,
    gradientTransform: "matrix(0.01, -59.35, 67.88, 0, 1302.74, -12622.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#091922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0d1a22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#191c20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211e1f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "59.23 25.31 51.42 24.95 51.19 30.13 59 30.49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.81,26.91a1.44,1.44,0,0,1,.95,1s0,0,0,0a1.33,1.33,0,0,1-.22.86h0a3.64,3.64,0,0,0-.22-1,1.21,1.21,0,0,0-.76-.65,6.92,6.92,0,0,0-6,1l-.33-.06c3.37-2,5.72-1.43,6.48-1.16h.05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -213.67,
    y1: -15.87,
    x2: -213.64,
    y2: -15.87,
    gradientTransform: "matrix(-0.02, -222.6, 222.58, -0.06, 3583.14, -47532.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#193a4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223f50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.2,
    y: 24.71,
    width: 9.28,
    height: 8.58,
    transform: "translate(8.59 70.14) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.4,25a4.59,4.59,0,0,1,2.37,2.89,1.51,1.51,0,0,0-1-1c-.7-.25-3.09-.94-6.53,1.15A9.46,9.46,0,0,0,54.6,32.2c1.25.87,1.93.75,2.37.6a4.67,4.67,0,0,1-4.62.38,4.55,4.55,0,0,1,3.53-8.37,4.71,4.71,0,0,1,.52.21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -214.56,
    cy: -16.04,
    r: 0.04,
    gradientTransform: "matrix(0.03, -205.32, 205.28, 0.01, 3354.39, -44024.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7daec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#c7daec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b3cbe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7fa6cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5f8fc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#081b22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5d81bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d81bf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.84,
    y: 17.89,
    width: 13.23,
    height: 17.09,
    transform: "translate(9.41 66.18) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.44,
    y: 8.69,
    width: 13.34,
    height: 44.82,
    transform: "translate(13.46 81.22) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.44,
    y: 8.69,
    width: 13.34,
    height: 44.81,
    transform: "translate(13.46 81.22) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.07,
    y: 21.99,
    width: 9.4,
    height: 9.4,
    transform: "translate(6.72 62.87) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.2,28.25a4.7,4.7,0,1,1-2.87-6,4.7,4.7,0,0,1,2.87,6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -215.55,
    cy: -16.15,
    r: 0.04,
    gradientTransform: "matrix(0.03, -194.72, 194.68, 0.01, 3199.29, -41946.05)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.51,
    y: 26.46,
    width: 3.98,
    height: 2.84,
    transform: "translate(7.42 66.25) rotate(-70.59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.83,28.37c-.36,1-1.25,1.65-2,1.39-.91-.32-1.05-1.31-.69-2.34s1.27-1.67,2-1.41,1.15,1,.67,2.36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -215.93,
    cy: -18.03,
    r: 0.04,
    gradientTransform: "matrix(0.02, -74.65, 74.64, 0.01, 1400.1, -16090.64)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.44,
    y: 21.15,
    width: 4.06,
    height: 8.56,
    transform: "translate(8.36 62.68) rotate(-70.57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.6,24.38l.34.15h0a1.65,1.65,0,0,1,.72.63h0s0,0,0,0a0,0,0,0,0,0,0v0s0,0,0,0v0h0s0,0,0,0a1,1,0,0,1-.29.95h0a4.6,4.6,0,0,0-.25-1.17,2.13,2.13,0,0,0-.87-.54A9.24,9.24,0,0,0,44.13,26l-.37-.08c3.85-2.35,7-1.84,7.82-1.54h0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -215.26,
    cy: -16.51,
    r: 0.04,
    gradientTransform: "matrix(-0.01, -217.55, 217.51, -0.03, 3642.39, -46803.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#223f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#223f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#204a63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1e5779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e5779"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.98,
    y: 21.67,
    width: 10.54,
    height: 9.9,
    transform: "translate(6.43 62.34) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.07,22.07a5.12,5.12,0,0,1,2.68,3.27,1.73,1.73,0,0,0-1.15-1c-.79-.29-4-.83-7.84,1.54,1.49,3.39,3.47,4.4,4.75,4.85a3.26,3.26,0,0,0,1.18.19,1.85,1.85,0,0,0,1.45-.47h0a5,5,0,0,1-5.66.83,5.16,5.16,0,0,1,4-9.49,4.35,4.35,0,0,1,.59.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.9,
    y: -42.35,
    width: 49.5,
    height: 147.87,
    transform: "translate(49.4 132.98) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -215.35,
    cy: -15.87,
    r: 0.04,
    gradientTransform: "matrix(0.03, -233.97, 233.93, 0, 3769.01, -50359.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7daec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#c7daec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#aac5e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6190c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#5f8fc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#081b22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5d81bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d81bf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.74,
    y: 16.57,
    width: 3.01,
    height: 8.15,
    transform: "translate(13.4 60.23) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.27,20.35a7.32,7.32,0,0,1,1.35,2.78c0,.12,0,.13,0,.13l-.19,0c-.07,0-.1,0-.14-.05a6.22,6.22,0,0,0-.88-1.3A6.1,6.1,0,0,0,49,20.46a4.82,4.82,0,0,0-3.44-.11c-.27.08-.24,0-.24,0s-.06-.17-.07-.24-.06-.09.07-.16c2.3-1.36,3.82-.91,4.26-.76h0a3.94,3.94,0,0,1,1.7,1.18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.36,
    y: 16.38,
    width: 3,
    height: 8.14,
    transform: "translate(14 60.67) rotate(-70.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.02,
    y: 20.77,
    width: 2.73,
    height: 6.37,
    transform: "translate(15.03 69.16) rotate(-70.56)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,23.68a6.75,6.75,0,0,1,1,2.38c0,.1,0,.11-.07.11l-.17,0,0,0h-.06a.11.11,0,0,1,0-.05A5.77,5.77,0,0,0,57.9,25a4.63,4.63,0,0,0-1.76-1.21,3.46,3.46,0,0,0-2.68,0c-.21.07-.18,0-.19,0s0-.14,0-.2,0-.07.06-.14c1.84-1.24,2.69-1,3.35-.79A3.34,3.34,0,0,1,58,23.68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.63,
    y: 20.57,
    width: 2.73,
    height: 6.36,
    transform: "translate(15.65 69.61) rotate(-70.58)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,36.75C0,29,0,21.21,0,13.43.06,5.27,6.22-.08,14.88,0,28,.13,40.93,1.93,53.94,3c2.84.24,5.69.41,8.51.74,6.47.78,11.65,5.78,11.73,11.93.19,14.05.23,28.11,0,42.15-.08,5.31-4.63,11.42-11.93,12Q46.63,71.1,31,72.65c-6.55.65-13.1,1.33-19.66.55A12.85,12.85,0,0,1,0,61C0,52.9,0,44.83,0,36.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.33,36.78c0-7.77,0-15.54,0-23.31C4.38,5.32,10.19,0,18.34.05,30.68.17,42.87,2,55.12,3.06c2.68.23,5.36.4,8,.74a12.43,12.43,0,0,1,11,11.91c.18,14,.22,28.09,0,42.13A12.52,12.52,0,0,1,63,69.84q-14.72,1.25-29.4,2.8C27.39,73.29,21.22,74,15,73.2A12.57,12.57,0,0,1,4.37,61c-.08-8.07,0-16.14,0-24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40,15.89,59.81,58.36a1.52,1.52,0,0,1-1,2.31c-4.84,1.5-6-2.61-7.72-5.05L37.23,32.08a.47.47,0,0,0-.8,0c-.48.51-8.77,8.33-8.77,8.33-4,4.07-8.64,2.28-7.55,0l6.6-9.74c5.06-7.77-.58-6.36-.89-16.84a2.37,2.37,0,0,1,2.83-2.68s5.08,1.08,7.16,1.43C38.61,12.92,40,15.89,40,15.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.16,37.19l4,6.67A2,2,0,0,1,41,46L29.56,60.66c-2.66,3.71-6.83-.41-3.61-5.6,0,0,9.26-17.06,9.56-17.68A.9.9,0,0,1,37.16,37.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.85,17.52l-2.63,6.21,5.08,6.82L56.93,38a1.58,1.58,0,0,0,2.5-.87L64,26.3a1.86,1.86,0,0,0-1-2.66L45.27,16.11Zm3.25,4.9a1.47,1.47,0,1,1-2.7-1.15,1.47,1.47,0,1,1,2.7,1.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 50.25,
    y: 24.96,
    width: 8.3,
    height: 8.31,
    transform: "translate(8.85 70.74) rotate(-70.57)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 55.26,
    y: 29.16,
    width: 3.55,
    height: 2.43,
    transform: "matrix(0.33, -0.94, 0.94, 0.33, 9.43, 74.07)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 52.62,
    y: 23.81,
    width: 5.19,
    height: 7.82,
    transform: "translate(25 81.61) rotate(-87.39)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 49.2,
    y: 24.71,
    width: 9.28,
    height: 8.58,
    transform: "translate(8.59 70.14) rotate(-70.58)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M51.28,28.06A9.46,9.46,0,0,0,54.6,32.2c1.25.87,1.93.75,2.37.6,0,0,.41-.14.53-.91a4.54,4.54,0,0,1-.66.59c-.24.11-.48.27-1.29,0a7.93,7.93,0,0,1-3.94-4.35"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 43.07,
    y: 21.99,
    width: 9.4,
    height: 9.4,
    transform: "translate(6.72 62.87) rotate(-70.58)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 48.51,
    y: 26.46,
    width: 3.98,
    height: 2.84,
    transform: "translate(7.42 66.25) rotate(-70.59)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 46.44,
    y: 21.15,
    width: 4.06,
    height: 8.56,
    transform: "translate(8.36 62.68) rotate(-70.57)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 41.98,
    y: 21.67,
    width: 10.54,
    height: 9.9,
    transform: "translate(6.43 62.34) rotate(-70.58)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M44.13,26a6.94,6.94,0,0,0,4.42,4.41,2.24,2.24,0,0,0,2.39-.26,4.76,4.76,0,0,0,.77-.9h0a1.93,1.93,0,0,1-.4,1.07,1.86,1.86,0,0,1-1.62.64h0a3.26,3.26,0,0,1-1.18-.19c-1.28-.45-3.26-1.46-4.75-4.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M49.54,19.15c-.44-.14-2-.59-4.26.77-.13.07-.07.09-.07.16s.06.19.07.24,0,.12.24,0a4.82,4.82,0,0,1,3.44.11,6.1,6.1,0,0,1,2.4,1.47,6,6,0,0,1,.88,1.3c0,.08.07.06.14.05l.19,0s.08,0,0-.13a7.32,7.32,0,0,0-1.35-2.78,4.16,4.16,0,0,0-1.73-1.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 13,
    transform: "translate(45.5 17.4) scale(0.48)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAANCAYAAABLjFUnAAAACXBIWXMAABcRAAAXEQHKJvM/AAACPklEQVQoU53P204TURSA4b+dzkAFQgsIhWIU8AZBDnIwMSYcfA7u8RKfgDvDY2DQGB/ApMHEqFAKJtKDIhFp0TZt7YHSlnY6M53ZXpgYjAfU73bt9WdtmxBCpNJpctk8bW1uvN4e/pcDIB5PEApHOCkWkWWZqckJ+vuu0O3xnLP+IwfAxoafak2lUq2g6zqxTzHsNjuSQ2J+Zpbrw0Nc6u09r4UtdnQkHj1+QjabxbQsTNMEBHXTpF43MHQDS1iMj44xNjrCnbm538d86+vi+YuX2ATY7RKaViMYCiJJEoosY1kWjQ2NyA0KpmXhdDqZmpzg2uAg87OzP8Skck1b3g2FGBka5jAWxe1243K5sDskLGyoNZWDgw8c53LIDgeGYRCLxQhHImz6t8jn8mg1Da+3B4fX42Hm1m1aXa04nY1kM1mKhQKZZJJSuYSq67R1dGDoOu/29lAUBU+3h5amFrRajeNcllAwiKZpSDvbgeWBgX6qVZVC4QRLCHRdxzB0qqqKqlbJH+c5rVRob+9AYJFMJpEcEmbdRNc0DF1j6d4SNiGEOPvvN7tB3u/vEw6HiCcSaFqNaDRK8fSUUvmU5uYmLigNJFMpujxdtLe6uLu4yMLCws+xs8KRt+y83mErsM3nRJxkKkk6k0GRFZyKTKlUprPzImurD7gxPv7n2FlPfT5868945d8k/SWNoesoNhumgHQ8/u2R+EcHHw/F6sM10d3XJy5fHRD3V1a+z/76sl/xBwJIdjs3p6cB+Apd41sQ7dnsLwAAAABJRU5ErkJggg=="
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M56.64,22.6c-.66-.24-1.51-.45-3.35.79-.1.07-.06.08-.06.14s0,.16,0,.2,0,.1.19,0a3.46,3.46,0,0,1,2.68,0A4.63,4.63,0,0,1,57.9,25a5.77,5.77,0,0,1,.72,1.18c0,.07.06.07.12.06l.17,0s.08,0,.07-.11a6.75,6.75,0,0,0-1-2.38,3.34,3.34,0,0,0-1.32-1.08"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("image", {
    width: 16,
    height: 11,
    transform: "translate(53.18 21.24) scale(0.48)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAACXBIWXMAABcRAAAXEQHKJvM/AAABuklEQVQoU42QT2/SAByGnzImus1CqECB6rxNHWxHdxFjcF486DdwH8TLPoZm0U9gdtSZaKJb98dl6oGyoQcYrcSWIoYORkpLPUyniSbynH5588uTvK8QBEEA8PzFSwRBIJ2WmZ/LMyrCL8GjxytYtg2A73ssLFzn6swVpi9d/L9gQ93kzfoGTbuJ6w7wAx9v4DEc+kTFKIvFIvNzeZRs9t+ClSdP2a98IhwKIYQEatUaQ9+j1zsmHo/jDlzGxsfJZjLcWbxN7tosspwCIFw+OGDt1WvOhMeQJImh5yFGRTqOgy8co26pTJw9h5LJ0HU6NL4YZOQ0uVyOYrFIuKyVOT81ya3CTSzTRNd1mqbFYb1Gr98nMjlBf+DxUSsxrSiIokjXcThyOhQKN04qWM0mpmmxs/MOw9Cp1+u0222MhsH3Tof+wMXzA/pHDoosE4vFSEoXeLa6ShggmUiQTCTI52b5aprs7u5R0kpI1QS6oWO3Wtitb3SFENW6zmUBlh4s/R7xr2l/omn77H14z1tVpfK5wqFuYNs2U5EIVqNx8hSMyLq6GTxcXg7EVCq4e//eaT6y4E+2trdP7x80bUDm7v3kugAAAABJRU5ErkJggg=="
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M38,21.63a6.27,6.27,0,0,1-1.25-.21c-.34-.15.72-1.23.72-1.23l.65.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.89,14.5c-.86,2.39,13.26,7.64,13.26,7.64a.14.14,0,0,1,.22-.06,1.59,1.59,0,0,1-.47,1.3c-.28.26-.73-.18-.73-.18s-9.92-3-12.06-6.39A6.4,6.4,0,0,1,25.89,14.5Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.09b42949835cf67626d0d482e634de13.svg";
export { ForwardRef as ReactComponent };